export * from './IconAlarmClock';
export { default as IconAlarmClock } from './IconAlarmClock';
